import FormForgotPasswordSetNew from './FormForgotPasswordSetNew';

export default FormForgotPasswordSetNew;
